export interface NavLink {
  id: string;
  title: string;
  url: string;
  description: string;
  status: 'online' | 'slow' | 'offline';
  speed?: string;
}

export const navigationLinks: Record<string, NavLink[]> = {
  'official-entry': [
    { id: 'oe-1', title: '爱情岛论坛 - 主站入口', url: 'https://www.aiqingdao.com', description: '官方主域名入口，推荐首选访问', status: 'online', speed: '极快' },
    { id: 'oe-2', title: '爱情岛论坛 - 镜像站A', url: 'https://www.aiqingdao.cn', description: '官方镜像站点，内容实时同步', status: 'online', speed: '快' },
    { id: 'oe-3', title: '爱情岛论坛 - 镜像站B', url: 'https://www.aiqingdao.net', description: '官方镜像站点，海外用户推荐', status: 'online', speed: '较快' },
    { id: 'oe-4', title: '爱情岛论坛 - CDN加速入口', url: 'https://cdn.aiqingdao.com', description: '通过CDN加速访问，适合高峰期', status: 'online', speed: '极快' },
  ],
  'backup-links': [
    { id: 'bl-1', title: '备用线路一（电信优化）', url: 'https://bak1.aiqingdao.com', description: '中国电信网络优化线路', status: 'online', speed: '快' },
    { id: 'bl-2', title: '备用线路二（联通优化）', url: 'https://bak2.aiqingdao.com', description: '中国联通网络优化线路', status: 'online', speed: '较快' },
    { id: 'bl-3', title: '备用线路三（移动优化）', url: 'https://bak3.aiqingdao.com', description: '中国移动网络优化线路', status: 'online', speed: '快' },
    { id: 'bl-4', title: '备用线路四（教育网）', url: 'https://edu.aiqingdao.com', description: '教育网专用线路', status: 'slow', speed: '一般' },
    { id: 'bl-5', title: '备用线路五（海外专线）', url: 'https://global.aiqingdao.com', description: '海外用户专属线路', status: 'online', speed: '极快' },
    { id: 'bl-6', title: '备用线路六（应急入口）', url: 'https://emergency.aiqingdao.com', description: '紧急情况下的临时访问入口', status: 'offline', speed: '-' },
  ],
  'community-resources': [
    { id: 'cr-1', title: '精华帖汇总专区', url: 'https://www.aiqingdao.com/featured', description: '论坛精选优质内容集中展示', status: 'online' },
    { id: 'cr-2', title: '新人引导专区', url: 'https://www.aiqingdao.com/guide', description: '新用户必读的入门指引内容', status: 'online' },
    { id: 'cr-3', title: '活动中心', url: 'https://www.aiqingdao.com/events', description: '论坛线上线下活动信息汇总', status: 'online' },
    { id: 'cr-4', title: '勋章墙', url: 'https://www.aiqingdao.com/badges', description: '用户荣誉勋章展示与获取攻略', status: 'online' },
    { id: 'cr-5', title: '问答互助专区', url: 'https://www.aiqingdao.com/qa', description: '用户互助问答交流平台', status: 'online' },
  ],
  'latest-news': [
    { id: 'ln-1', title: '论坛公告栏', url: 'https://www.aiqingdao.com/announcements', description: '官方最新公告与重要通知', status: 'online' },
    { id: 'ln-2', title: '版本更新日志', url: 'https://www.aiqingdao.com/changelog', description: '论坛功能更新与优化记录', status: 'online' },
    { id: 'ln-3', title: '活动预告', url: 'https://www.aiqingdao.com/upcoming', description: '即将上线的活动和功能预告', status: 'online' },
  ],
  'tutorials': [
    { id: 'tu-1', title: '新手指南完整版', url: 'https://www.aiqingdao.com/help/beginner', description: '从注册到熟练使用的完整教程', status: 'online' },
    { id: 'tu-2', title: '发帖格式教程', url: 'https://www.aiqingdao.com/help/posting', description: '帖子排版、图片上传等操作指南', status: 'online' },
    { id: 'tu-3', title: '积分获取攻略', url: 'https://www.aiqingdao.com/help/points', description: '快速提升用户等级的方法汇总', status: 'online' },
    { id: 'tu-4', title: '隐私设置教程', url: 'https://www.aiqingdao.com/help/privacy', description: '保护个人信息的设置指南', status: 'online' },
    { id: 'tu-5', title: 'VIP会员指南', url: 'https://www.aiqingdao.com/help/vip', description: 'VIP会员权益与开通教程', status: 'online' },
  ],
  'mobile-access': [
    { id: 'ma-1', title: '移动端网页版', url: 'https://m.aiqingdao.com', description: '手机浏览器直接访问的移动版', status: 'online', speed: '快' },
    { id: 'ma-2', title: 'Android APP下载', url: 'https://www.aiqingdao.com/app/android', description: '安卓手机专用客户端', status: 'online' },
    { id: 'ma-3', title: 'iOS APP下载', url: 'https://www.aiqingdao.com/app/ios', description: '苹果手机专用客户端', status: 'online' },
    { id: 'ma-4', title: '小程序入口', url: 'https://www.aiqingdao.com/miniapp', description: '微信小程序快捷访问', status: 'online', speed: '快' },
  ],
};